import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http'
import { ResourceService } from '@smartsoftware/reflex-core';
import { SyncVendorEntityField } from '../models';

@Injectable()
export class SyncVendorEntityField_Service extends ResourceService<SyncVendorEntityField> {
    protected servicePath: string = '/SyncVendorEntityField';

    public ModelType = SyncVendorEntityField;

    constructor(
        protected http: HttpClient
    ) {
        super(http);
    }

    public getFields(filter: any) {
        let params = new HttpParams()
            .append('params', btoa(JSON.stringify(filter)));

        return this.http.get<SyncVendorEntityField[]>(`${this.serviceUrl}getFields`, { params });
    }
}
